import React from 'react'
import PropTypes from 'prop-types'

const Value = ({ title, description, position, hasPreface, style }) => (
  <div className={`value-container ${position}`} style={style}>
    <div className="value">
      {hasPreface && (
        <div className="preface-container">
          <p className="preface">Why IrisVR</p>
        </div>
      )}
      <div className="title-container">
        <p className="value-title">{title}</p>
      </div>
      <div className="desc-container">
        <p className="value-desc">{description}</p>
      </div>
    </div>
  </div>
)

Value.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  hasPreface: PropTypes.bool.isRequired,
  hasCta: PropTypes.bool.isRequired,
}

export default Value
